import React from "react";
import GroupedBarChart from "../../Shared/GroupedBarChart";

const ApplicationStatusChart = (props) => {
  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const handleSelectFilter = (SelectedID, ENUM) => {
    props.SetStatusIsActive(true);
    props.SaveSelectedStatus(ENUM);

    let Size = 5;
    if (document.getElementById("pre-selected-row-per-page") !== null) {
      Size = parseInt(
        document.getElementById("pre-selected-row-per-page").innerHTML
      );
    }
    props.FetchData(Size, 0, ENUM);

    props.AppStatusChartBtnIds.map((Id) => {
      document.getElementById(Id).classList.remove("active-action-btn");
    });
    props.BarChartBtnIds.map((Id) => {
      if (document.getElementById(Id)) {
        document.getElementById(Id).classList.remove("active-action-btn");
      }
    });
    document.getElementById(SelectedID).classList.add("active-action-btn");
  };
  return (
    <div className="filter-chart-wrapper mobile-grid">
      <h3 className="section-title">{translateText("application_status")}</h3>
      <div className="group-barchart-holder">
        <section className="buttons-wrapper btn-wrapper-bg">
          <span
            id="not-started"
            onClick={() => handleSelectFilter("not-started", "NOT_STARTED")}
            className="chart-action"
          >
            {translateText("not_started")}
          </span>
          <span
            id="new"
            onClick={() => handleSelectFilter("new", "NEW")}
            className="chart-action"
          >
            {translateText("new")}
          </span>
          <span
            id="in-progress"
            onClick={() => handleSelectFilter("in-progress", "IN_PROGRESS")}
            className="chart-action"
          >
            {translateText("in_progress")}
          </span>
          <span
            id="accepted"
            onClick={() => handleSelectFilter("accepted", "ACCEPTED")}
            className="chart-action"
          >
            {translateText("jpa_status_accepted")}
          </span>
          <span
            id="popular"
            onClick={() => handleSelectFilter("popular", "POPULAR")}
            className="chart-action"
          >
            {translateText("popular")}
          </span>
        </section>
        <GroupedBarChart Data={props.Data} />
      </div>
      <aside className="chart-hint">
        <section className="hint-item">
          <span className="hint-circle blue-circle"></span>
          <p>{translateText("vacancies")}</p>
        </section>
        <section className="hint-item">
          <span className="hint-circle red-circle"></span>
          <p>{translateText("projects")}</p>
        </section>
        <section className="hint-item">
          <span className="hint-circle purple-circle"></span>
          <p>{translateText("activities")}</p>
        </section>
      </aside>
    </div>
  );
};

export default ApplicationStatusChart;
